"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
const createConfig_1 = tslib_1.__importDefault(require("../config/createConfig"));
const logNewRelicError = (message, ...optionalParams) => {
    if (window.newrelic === undefined)
        return;
    // If the first optionalParam is an object, send it.
    const nrOptionalAttributes = optionalParams && optionalParams[0] && optionalParams[0] instanceof Object
        ? optionalParams[0]
        : undefined;
    try {
        window.newrelic.noticeError(message, nrOptionalAttributes);
    }
    catch {
        // Fail silently
    }
};
const createLogger = (options) => {
    const { config } = (0, createConfig_1.default)();
    const { consoleEnabled, newRelicEnabled } = options ||
        config("logger") || { consoleEnabled: false, newRelicEnabled: false };
    const error = (message, ...optionalParams) => {
        if (consoleEnabled)
            console.error(message, ...optionalParams);
        if (newRelicEnabled)
            logNewRelicError(message, ...optionalParams);
    };
    const assert = (condition, ...data) => {
        if (condition)
            error(...data);
    };
    const info = (message, ...optionalParams) => {
        if (consoleEnabled)
            console.info(message, ...optionalParams);
    };
    const log = (message, ...optionalParams) => {
        if (consoleEnabled)
            console.log(message, ...optionalParams);
    };
    const trace = (message, ...optionalParams) => {
        if (consoleEnabled)
            console.trace(message, ...optionalParams);
    };
    const warn = (message, ...optionalParams) => {
        if (consoleEnabled)
            console.warn(message, ...optionalParams);
    };
    return {
        assert,
        error,
        info,
        log,
        trace,
        warn,
    };
};
exports.default = createLogger;
//# sourceMappingURL=createLogger.js.map